import React from "react";
import { UI_CAPTION_SEMIBOLD, UI_TITLE } from "oolib";
import { LandingCompContainerStyled } from "./styled";
import { ChatbotInfo } from "../ChatbotInfo";
import { PopOutBadge } from "@/components/PopOutBadge";

/**
 * The empty chat on a tenant with no topic tree. Split-mode tenants get
 * SuggestionsLanding in this slot instead — the same suggested questions the
 * dashboard's Ask AI widget offers, with its own greeting.
 */
export const LandingComp = () => {
  return (
    <LandingCompContainerStyled>
      {" "}
      <div style={{ display: "flex", flexDirection: "column", gap: "1.4rem" }}>
        <div style={{ display: "flex", gap: ".5rem", alignItems: "center" }}>
          <UI_TITLE>Ask AI</UI_TITLE>{" "}
          <PopOutBadge/>
        </div>
        <ChatbotInfo />
      </div>
    </LandingCompContainerStyled>
  );
};
